import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';
import { useDeclination } from '@cp/shared/declination';

export const useReplies = (data: CatalogItemViewModel | undefined): null | string => {
  const declination = useDeclination();

  if (!data || typeof data.repliesCount !== 'number') {
    return null;
  }

  return `${data.repliesCount} ${declination(data.repliesCount, DeclinationMnemonic.Reply)}`;
};
